<!-- MULTISELECT BIDIRECCIONAL POR SI SE MODIFICA EL V-MODEL EN EL PADRE O HIJO -->

<template>
  <div>
    <multiselect 
      v-model="computedSelected" 
      :options="options" 
      :multiple="true" 
      :track-by="valorGuardar"
      :label="valorVer" 
      :searchable="true" 
      :close-on-select="false" 
      :clear-on-select="false" 
      :preselect-first="selectFirst"
      :allow-empty="allowEmptyList"
      placeholder="Selecciona opciones"
      selectLabel="Presiona enter para añadir" 
      selectedLabel="añadido"
      deselectLabel="Presiona enter para eliminar"
    >
      <template #noOptions>
        {{ emptyList }}
      </template>

      <template #noResult>
        {{ badSearch }}
      </template>
    </multiselect>
    
    <span v-if="!computedSelected.length && dataRequired" class="text-danger">
      Este campo es requerido.
    </span>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    valorGuardar: {
      type: String,
      default: 'id'
    },
    valorVer: {
      type: String,
      default: 'name'
    },
    allData: {
      type: Boolean,
      default: true,
    },
    selectFirst: {
      type: Boolean,
      default: true,
    },
    emptyList: {
      type: String,
      default: "¡Lo sentimos! No hemos encontrado valores.",
    },
    badSearch: {
      type: String,
      default: "¡Ops! Revisa tu búsqueda.",
    },
    allowEmptyList: {
      type: Boolean,
      default: true,
    },
    dataRequired: {
      type: Boolean,
      default: true
    },
    dataPreload: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    computedSelected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', this.processSelectedData(newValue));
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.$emit('input', []);
      },
      deep: true
    },
    dataPreload: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.$emit('input', this.processSelectedData(newVal));
        }
      },
      deep: true
    }
  },
  methods: {
    processSelectedData(data) {
      if (!this.allData) {
        return data.map(item => item[this.valorGuardar]);
      }
      return data;
    }
  }
};
</script>

<style scoped>
.text-danger {
  color: red;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>